







import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AddEditList from '@/components/AddEditList.vue';
import { UserModule } from '@/store/modules/user';

@Component({ components: { AddEditList } })
export default class EditList extends Vue {
  @Prop(String) public listId?: string;
  @Prop(String) public slug?: string;
  @Prop(String) public username?: string;
  public list: ListModel = null;
  public error: boolean = false;

  get canEditList(): boolean {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  public async findList(): Promise<firebase.firestore.DocumentReference> {
    if (this.listId) {
      return ListModelUtil.findListRefFromId(this.listId);
    } else if (this.slug && this.username) {
      return ListModelUtil.findListRefFromSlug({
        username: this.username,
        slug: this.slug
      });
    } else {
      throw new Error('missing things');
    }
  }

  public async loadList() {
    try {
      

      const doc = await this.findList();
      const list = await doc.get();

      this.list = ListModel.fromFirebaseDoc(doc.id, list.data());
      if (
        this.slug &&
        this.username &&
        (this.slug != this.list.slug || this.username != this.list.username)
      ) {
        this.$router.replace(this.list.editLink);
      }

      if (!this.canEditList) {
        this.error = true;
        this.list = null;
      }
      document.title = `mixlet: Edit ${this.list.title} - ${this.list.username}`;
      
    } catch (e) {
      this.error = true;
    }
  }

  public created() {
    this.loadList();
  }
}
